import api from '../../api';

const listSubscriptionPlans = async (
    subscriptionId:any,
    leadId:any,
    preferredPlatform: string | null = null,
) => {
  const SubscriptionPlansData = await new api.Subscription(subscriptionId)
      .getSubscriptionPlans(leadId, preferredPlatform)
      .then((res:any) => {
        return res?.data;
      })
      .catch((error:any)=>{
        console.log(error);
        return error?.response?.data?.errors[0];
      });

  return SubscriptionPlansData;
};

export {
  listSubscriptionPlans,
};
